export type {
  DrawerHeaderProps as NavDrawerHeaderProps,
  DrawerHeaderSlots as NavDrawerHeaderSlots,
  DrawerHeaderState as NavDrawerHeaderState,
} from '../../Drawer/DrawerHeader/DrawerHeader.types';
